"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var MathManip_exports = {};
__export(MathManip_exports, {
  default: () => MathManip_default
});
module.exports = __toCommonJS(MathManip_exports);
var React = __toESM(require("react"));
var import_styled_components = __toESM(require("styled-components"));
const SvgIcon = ({
  title,
  titleId,
  desc,
  descId,
  iconSize,
  ariaHidden,
  ...props
}) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    ...props,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    color: "currentColor",
    role: "img",
    "aria-labelledby": titleId,
    "aria-describedby": descId
  },
  desc ? /* @__PURE__ */ React.createElement("desc", { id: descId }, desc) : null,
  title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null,
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M17.9803 14.6664C19.7912 13.5772 21 11.56 21 9.26106C21 5.81962 18.2851 3 14.9 3C12.1515 3 9.84491 4.85874 9.07449 7.3999H4.60001C3.71635 7.3999 3.00001 8.11625 3.00001 8.9999V15.5999C3.00001 16.4836 3.71635 17.1999 4.60001 17.1999H9.86956L9.17449 18.731C9.06293 18.9767 9.05762 19.2598 9.23467 19.4635C9.70804 20.0081 11.0445 21 14.5 21C17.9555 21 19.292 20.0081 19.7653 19.4635C19.9424 19.2598 19.9371 18.9767 19.8255 18.731L17.9803 14.6664ZM14.9 4.2C12.21 4.2 10 6.44947 10 9.26106C10 10.5695 10.4387 12.1808 11.7187 13.1267L14.1358 7.80228C14.2778 7.48941 14.7222 7.48941 14.8642 7.80228L17.4801 13.5645C18.8687 12.6741 19.8 11.0837 19.8 9.26106C19.8 6.44947 17.59 4.2 14.9 4.2ZM10.4143 15.9999L11.2139 14.2385C9.34047 13.0056 8.8 10.8167 8.8 9.26106C8.8 9.03786 8.81142 8.81727 8.8337 8.5999H4.60001C4.37909 8.5999 4.20001 8.77899 4.20001 8.9999V15.5999C4.20001 15.8208 4.37909 15.9999 4.60001 15.9999H10.4143ZM10.4092 18.9142L14.5 9.90295L18.5908 18.9142C18.1147 19.2587 16.976 19.8 14.5 19.8C12.024 19.8 10.8853 19.2587 10.4092 18.9142Z",
      fill: "currentColor"
    }
  )
);
const SvgMathManip = (0, import_styled_components.default)(SvgIcon)(({ iconSize, color }) => {
  const getIconSize = () => {
    const standardIconSize = {
      s: "17px",
      // 17px small
      m: "20px",
      // 20px medium
      l: "24px",
      // 24px large
      xl: "32px",
      // 32px extraLarge
      inherit: "inherit"
      // inherits size from parent
    };
    return standardIconSize[iconSize];
  };
  return import_styled_components.css`
    width: ${getIconSize()};
    height: ${getIconSize()};
    display: inline-block;
    color: ${color};
  `;
});
var MathManip_default = SvgMathManip;
